<div #mainDiv_ll_build_form_holder>
  <div *ngIf="bundle.showPanel"
       [style.top.px]="bundle.panelY"
       [style.left.px]="bundle.panelX"
       style="position: absolute;">

    <jqxPanel [autoUpdate]="true"
              [width]="bundle.panelW"
              [height]="bundle.panelH"
              style="background-color: transparent; border: none; border-bottom: 2px solid rgb(160, 158, 158);">

        <ll-build-form></ll-build-form>

    </jqxPanel>
  </div>
</div>

